import styled from "@emotion/styled";

interface IProgressBar{ height?: any, borderRadius?: any, backgroundColor?: any, fillColor?: any, progressWidth?: any};

export const FailureScreenLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  button {
    margin-bottom: 12px;
  }
`;

export const FailureScreenTitleWrapper = styled.div`
  text-align: center;
  margin-top: 24px;
  p:first-of-type {
    margin-bottom: 36px;
  }
`;

export const ProgressBarLayout = styled.div(({ height, borderRadius, backgroundColor }: IProgressBar) => ({
    position: "absolute",
    width: `calc(100% - 40px)`,
    bottom: "117px",
    height: height,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
}));

export const ProgressBarFill = styled.div<{
    borderRadius: string;
    fillColor: string;
    progressWidth: string;
    animationTime: string;
  }>`
    height: 100%;
    background-color: ${({ fillColor }) => fillColor};
    border-radius: ${({ borderRadius }) => borderRadius};
    animation: ${({ animationTime }) => `fillAnim ease ${animationTime} forwards`}; 

  @keyframes fillAnim {
    0% {
      width: 0%;
    }
    75% {
      width: 75%;
    }
    100% {
      width: ${({ progressWidth }) => progressWidth};
    }
  }
  `;